import { render, staticRenderFns } from "./competeBrand.vue?vue&type=template&id=64b38a96&scoped=true"
import script from "./competeBrand.vue?vue&type=script&lang=js"
export * from "./competeBrand.vue?vue&type=script&lang=js"
import style0 from "./competeBrand.vue?vue&type=style&index=0&id=64b38a96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b38a96",
  null
  
)

export default component.exports